module.exports = __webpack_public_path__ + "static/media/Galileo_badGuyDied.4fa336b1.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sound/Galileo_badGuyDied.wav
// module id = 188
// module chunks = 0